module.exports = __webpack_public_path__ + "static/media/Item_Weapon_UMP_C.635ce594.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_UMP_C.png
// module id = 245
// module chunks = 0